import React from "react";
import { useTranslation } from "react-i18next";
import { AlignLeft } from "lucide-react";
import ErrorMessage from "@/components/common/ErrorMessage";
import SimpleRichTextEditor from "@/components/common/SimpleRichTextEditor";

interface TaskDescriptionEditorProps {
  description: string;
  onChange: (value: string) => void;
  onSubmit: (value: string) => void;
  allowed: boolean;
  error?: string;
}

export const TaskDescriptionEditor: React.FC<TaskDescriptionEditorProps> = ({
  description,
  onChange,
  onSubmit,
  allowed,
  error,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 p-3 bg-white border border-slate-200/90 rounded-xl shadow-2xs">
      <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-700 border-b border-slate-100 pb-2">
        <AlignLeft className="w-3.5 h-3.5 text-slate-400" />
        <span>{t("description")}</span>
      </div>

      <SimpleRichTextEditor
        value={description || ""}
        disabled={!allowed}
        placeholder={t("task_description_placeholder")}
        onChange={(val: string) => onChange(val)}
        onBlur={() => {
          if (description !== undefined) {
            onSubmit(description);
          }
        }}
        className="min-h-0"
        editorClassName="h-[90px] min-h-[70px] max-h-[250px]"
      />

      {error && (
        <ErrorMessage className="text-xs mt-0.5">{t(error)}</ErrorMessage>
      )}
    </div>
  );
};

export default TaskDescriptionEditor;

